module.exports = __webpack_public_path__ + "static/media/redeem.37861fd1.svg";